<template>
  <article class="contenedor-hijo">
    <div class="container">
      <div class="row justify-content-center justify-content-md-between mb-3 ml-2 ml-sm-0">
        <div class="col-auto px-0">
          <mdb-btn
            flat
            dark-waves
            icon="arrow-left"
            type="button"
            title="Regresar"
            @click="$router.go(-1)"
          >
            Regresar
          </mdb-btn>
        </div>
        <div class="col-auto px-0">
          <mdb-btn
            v-if="factura.est_fac !== 'En carga'"
            flat
            dark-waves
            icon="pen"
            type="button"
            title="Editar factura"
            @click="facturaSeleccionada=factura; mostrarModalEditarFactura= !mostrarModalEditarFactura"
          >
            Editar factura
          </mdb-btn>
        </div>
      </div>
      <li
        v-if="cargando"
        class="mensaje-no-items py-3"
      >
        <LoaderKel />
        <p class="texto mt-2">
          Cargando
        </p>
      </li>
      <div v-else>
        <div class="encabezado-detalles">
          <header class="h4-responsive text-center pt-3">Detalles de la factura</header>
          <div
            class="row mx-0 mt-2"
            v-if="factura && factura.id_fac"
          >
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Nombre del vendedor</span>
              <p class="text-capitalize">{{factura.vendedor}}</p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Cliente, Sucursal</span>
              <p>
                <span :class="!(factura.nom_emp) ? 'text-muted font-italic user-select-none' : 'text-capitalize'">
                  {{factura.nom_emp ? factura.nom_emp : 'Cliente no especificado' }},
                </span>
                <span :class="!(factura.nom_suc) ? 'text-muted font-italic user-select-none' : 'text-capitalize'">
                  {{ factura.nom_suc ? factura.nom_suc : 'Sucursal no especificada' }}
                </span>
              </p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Fecha de factura</span>
              <p :class="['text-capitalize']">
                {{ formatearFechaPago(factura.fec_fac) }}
              </p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Fecha de vencimiento</span>
              <p :class="['text-capitalize']">
                {{ formatearFechaPago(factura.fec_ven_fac) }}
              </p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Número de factura</span>
              <p :class="['text-capitalize',{'text-muted font-italic user-select-none': !(factura.num_fac)}]">
                {{ factura.num_fac ? factura.num_fac : 'Sin número asignado' }}
              </p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Monto de factura</span>
              <p class="text-capitalize">{{ convertirNumeroAFixed(factura.mon_fac) }}</p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Estatus de la factura</span>
              <span :class="[diasEstatusFac(factura.fec_ven_fac, factura.fec_pag_fac).color, 'font-weight-bold']" v-if="factura.fec_ven_fac">
                {{factura.est_fac.slice(0,1).toUpperCase() + factura.est_fac.slice(1) }}
                <p> {{diasEstatusFac(factura.fec_ven_fac, factura.fec_pag_fac).dias}} días </p>
              </span>
              <p
                v-else
                class="text-muted font-italic user-select-none"
              >
                Sin especificar
              </p>
            </div>
            <div :class="[factura.obs_fac.length > 88 ? 'col-12' :'col', 'pr-sm-1']">
              <span class="small-block font-titulo">Observación de la factura</span>
              <p :class="{'text-muted font-italic user-select-none': !(factura.obs_fac)}">
                {{(factura.obs_fac && factura.obs_fac ) || 'Sin especificar'}}
              </p>
            </div>
          </div>
          <div
            v-else
            class="mensaje-no-items pb-3"
          >
            <font-awesome-icon icon="clipboard" size="5x" class="icono" />
            <p class="texto">Sin detalles de la factura</p>
          </div>
        </div>
        <header class="h4-responsive text-center pt-3">Pagos relacionados</header>
        <div
          class="encabezado-detalles"
          v-for="pag in pagos"
          :key="pag.id_aco"
        >
          <header
            class="h4-responsive text-left pt-3 pl-3 cursor-pointer"
            @click="$router.push(`/pagos/${pag.id_aco}`)"
          >
            Pago #{{pag.id_aco}}
            <font-awesome-icon icon="external-link-alt" class="ml-3 text-muted" size="xs" />
          </header>
          <div class="row mx-0 mt-2">
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Estatus del pago</span>
              <p
                v-if="pag.est_aco"
                :class="[asignarColorEstado(pag.est_aco), 'font-weight-bold'] "
              >
                {{pag.est_aco.slice(0,1).toUpperCase() + pag.est_aco.slice(1) }}
              </p>
              <p
                v-else
                class="text-muted font-italic user-select-none"
              >
                Sin especificar
              </p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Banco</span>
              <p :class="['text-capitalize', {'text-muted font-italic user-select-none': !(pag.nom_cba)}]">
                {{ pag.nom_cba ? pag.nom_cba : 'Sin banco especificado' }}
              </p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Moneda</span>
              <p class="text-capitalize">{{ pag.nom_mon }} / {{ pag.sim_mon }} </p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Método de pago</span>
              <p class="text-capitalize">{{ pag.nom_mep }}</p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Referencia de pago</span>
              <p :class="['text-capitalize',{'text-muted font-italic user-select-none': !(pag.ref_aco)}]">
                {{ pag.ref_aco ?  pag.ref_aco : 'Sin referencia especificada' }}
              </p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1" v-if="pag.id_mon_aco != '2'">
              <span class="small-block font-titulo">Tasa de cambio</span>
              <p class="text-capitalize">{{ convertirNumeroAFixed(pag.tas_aco) }}</p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1" v-if="pag.id_mon_aco != '2'">
              <span class="small-block font-titulo">Monto de pago</span>
              <p class="text-capitalize">{{ convertirNumeroAFixed(pag.mon_rec_aco) }} {{pag.sim_mon}}</p>
            </div>
            <div class="col-6 col-md-4 col-xl-3">
              <span class="small-block font-titulo">Monto en dólares</span>
              <p class="text-capitalize">{{ convertirNumeroAFixed(pag.mon_aco) }} $</p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Indexación del pago</span>
              <p :class="['text-capitalize',{'text-muted font-italic user-select-none': !(pag.ind_aco)} ]">{{ pag.ind_aco ? pag.ind_aco : 'Sin especificar'}}</p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Fecha notificado</span>
              <p class="text-capitalize">{{ pag.fec_cre_aco ? formatearFechaPago(pag.fec_cre_aco) : 'Sin fecha especificada' }}</p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Fecha recibido</span>
              <p class="text-capitalize">{{ pag.fec_rec_aco ? formatearFechaPago(pag.fec_rec_aco) : 'Sin fecha especificada' }}</p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Fecha depositado</span>
              <p class="text-capitalize">{{ pag.fec_dep_aco ? formatearFechaPago(pag.fec_dep_aco) : 'Sin fecha especificada' }}</p>
            </div>
            <div :class="[pag.obs_aco.length > 88 ? 'col-12' :'col', 'pr-sm-1']">
              <span class="small-block font-titulo">Observación</span>
              <p :class="{'text-muted font-italic user-select-none': !(pag.obs_aco)}">
                {{(pag.obs_aco && pag.obs_aco ) || 'Sin especificar'}}
              </p>
            </div>
          </div>
        </div>
        <!-- Total de pagos -->
        <div v-if="pagos.length">
          <header class="h4-responsive text-center pt-3">Resumen total de pagos</header>
          <div class="col-12">
            <ul class="table t-pagos">
              <li class="encabezado claro">
                <div class="thead claro py-2">
                  <div class="col col-md-3">
                    <span class="small-block titulo-table">Fecha de pago</span>
                  </div>
                  <div class="col col-md-2">
                    <span class="small-block titulo-table">Método de pago</span>
                    <span class="small-block font-subtitle">Número de pago #</span>
                  </div>
                  <div class="col col-md-1">
                    <span class="small-block titulo-table">Estado</span>
                  </div>
                  <div class="col col-md-2">
                    <span class="small-block titulo-table">Tasa</span>
                  </div>
                  <div class="col col-md-2">
                    <span class="small-block titulo-table">Monto en Bs.</span>
                  </div>
                  <div class="col col-md-2">
                    <span class="small-block titulo-table">Monto en dólares</span>
                  </div>
                </div>
              </li>
              <li class="contenido" v-for="pago in pagosContables" :key="pago.id_aco">
                <div class="col col-md-3" data-columna="Fecha de pago">
                  <p class="text-capitalize">{{ pago.fec_dep_aco ? formatearFechaPago(pago.fec_dep_aco) : 'Sin fecha especificada' }}</p>
                </div>
                <div class="col col-md-2" data-columna="Método de pago">
                  <p class="text-capitalize">{{ pago.nom_mep }}</p>
                  <p class="text-capitalize">Pago #{{ pago.id_aco }}</p>
                </div>
                <div class="col col-md-1" data-columna="Estado">
                  <p class="text-capitalize" :class="[asignarColorEstado(pago.est_aco), 'font-weight-bold']">{{ pago.est_aco }}</p>
                </div>
                <div class="col col-md-2" data-columna="Tasa">
                  <p class="text-capitalize">{{ convertirNumeroAFixed(pago.tas_aco) }}</p>
                </div>
                <div class="col col-md-2" data-columna="Monto en Bs.">
                  <p class="text-capitalize">{{ pago.sim_mon === '$' ? 0 : convertirNumeroAFixed(pago.mon_rec_aco) }} Bs.</p>
                </div>
                <div class="col col-md-2" data-columna="Monto en dólares">
                  <p class="text-capitalize">{{ convertirNumeroAFixed(pago.mon_aco) }} $</p>
                </div>
              </li>
              <li class="contenido">
                <div class="col col-md-10 hidden">
                  Total en dólares
                </div>
                <div class="col" data-columna="Total en dólares">
                  {{ convertirNumeroAFixed(totalPagos.monto_aco) }} $
                </div>
              </li>
              <li class="contenido">
                <div class="col col-md-10 hidden">
                  Total pendiente
                </div>
                <div class="col" data-columna="Total pendiente">
                  <span :class="Number(totalPagos.monto_ped.toFixed(2)) === 0 ? 'text-success': 'text-error'">
                    {{ convertirNumeroAFixed(totalPagos.monto_ped) }} $
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
          v-if="!pagos.length"
          class="mensaje-no-items pb-3"
        >
          <font-awesome-icon icon="clipboard" size="5x" class="icono" />
          <p class="texto">Sin detalles del pago</p>
        </div>
        <header class="h4-responsive text-center pt-3">Descuentos aplicados</header>
        <div
          class="encabezado-detalles"
          v-for="(ajuste, i) in ajustes"
          :key="i"
        >
          <div class="row mx-0 mt-2">
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Nombre</span>
              <p class="text-capitalize"> {{ ajuste.nom_catdes }} </p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Descuento</span>
              <p :class="['text-capitalize', {'text-muted font-italic user-select-none': !(ajuste.desc_catdes)}]">
                {{ ajuste.desc_catdes }}%
              </p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Total</span>
              <p class="text-capitalize">{{ ajuste.monto_afa }}</p>
            </div>
            <div class="col-12 col-sm-4 col-xl-3 pr-sm-1">
              <span class="small-block font-titulo">Fecha de asignación</span>
              <p class="text-capitalize">{{ ajuste.fec_afa }}</p>
            </div>
          </div>
        </div>
        <div
          v-if="!ajustes.length"
          class="mensaje-no-items pb-3"
        >
          <font-awesome-icon :icon="['fas', 'percent']" size="5x" class="icono" />
          <p class="texto">Sin descuentos relacionados</p>
        </div>
      </div>
    </div>
    <ModalEditarFactura
      :mostrarModalEditarFactura="mostrarModalEditarFactura"
      :facturaSeleccionada="facturaSeleccionada"
      @cerrar="mostrarModalEditarFactura = $event"
      @actualizar="obtenerDetallesFactura(); mostrarModalEditarFactura = false"
    />
    <AlertaMensaje
      :alertaMensaje="alertaMensaje"
      @cerrar="alertaMensaje.contenido = ''"
    />
  </article>
</template>

<script>
import { apiPost } from '@/funciones/api.js'
import { asignarColorEstado, convertirNumeroAFixed, diasEstatusFac } from '@/funciones/funciones.js'
import ModalEditarFactura from '@/components/Modals/ModalEditarFactura.vue'
import { mdbBtn } from 'mdbvue'
import AlertaMensaje from '@/components/AlertaMensaje.vue'
import LoaderKel from '@/components/LoaderKel.vue'

const ESTADOS_PAGO_CONTABLES = ['Notificado', 'Confirmado', 'Auditado']
const aNumero = (valor) => Number(valor) || 0

export default {
  name: 'FacturaView',
  components: {
    mdbBtn,
    AlertaMensaje,
    LoaderKel,
    ModalEditarFactura
  },
  data () {
    return {
      asignarColorEstado,
      convertirNumeroAFixed,
      diasEstatusFac,
      // Modal cambiar estatus a la factura
      mostrarModalEditarFactura: false,
      // factura
      pagos: [],
      factura: {},
      ajustes: [],
      facturaSeleccionada: {},
      botonDeshabilitado: false,
      cargando: false,
      alertaMensaje: {
        contenido: ''
      }
    }
  },
  computed: {
    pagosContables () {
      return this.pagos.filter((pago) => ESTADOS_PAGO_CONTABLES.includes(pago.est_aco))
    },
    totalPagos () {
      const montoPagado = this.pagosContables.reduce((acc, pago) => acc + aNumero(pago.mon_aco), 0)
      return {
        monto_aco: montoPagado,
        monto_ped: aNumero(this.factura.mon_fac) - montoPagado
      }
    }
  },
  mounted () {
    this.obtenerDetallesFactura()
  },
  methods: {
    async obtenerDetallesFactura () {
      this.cargando = true
      if (!this.$route.params.id) {
        this.$router.push('/')
        return
      }
      try {
        const { data } = await apiPost(
          { s: 'facturaMv' },
          'fac=' + Number(this.$route.params.id)
        )
        if (data) {
          this.factura = data.fac[0]
          this.pagos = data.pag
          this.ajustes = data.afa
        }
        this.cargando = false
      } catch (error) {
        this.alertaMensaje = {
          contenido: 'No se pudo obtener los detalles de la factura',
          tipo: 'error'
        }
        this.cargando = false
      }
    },
    formatearFechaPago (fechaPlana) {
      const mess = new Date(fechaPlana + 'Z-4:30')
      const opt = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      const mesLetras = mess.toLocaleDateString('es-VE', opt)
      return mesLetras
    }
  }
}
</script>

<style lang="scss" scoped>
.table.p-notas {
  // Define los breakpoints para el responsive de ul.table
  $breakpointToChange: "576px";
  @include ul-table-responsive-at ($breakpointToChange);
}

.text-error {
  color: red !important;
}
.font-subtitle{
  font-size: .7rem !important;
  font-weight: normal;
}

.titulo-table {
  font-weight: bold !important;
}

.table.t-pagos {
  .contenido>[class*=col] {
    line-height: 1.3
  }
  // Define los breakpoints para el responsive de ul.table
  @include ul-table-responsive-at ('768px');
}

@media (max-width:768px) {
  .hidden{
    display: none !important;
  }
}
</style>
